import { z } from 'zod';

export const NotificationType = {
  LEAD_ASSIGNED: 'LEAD_ASSIGNED',
  LEAD_NEW: 'LEAD_NEW',
  TASK_OVERDUE_DIGEST: 'TASK_OVERDUE_DIGEST',
  HANDOFF: 'HANDOFF',
  LEAD_REASSIGNED_AWAY: 'LEAD_REASSIGNED_AWAY',
  /** El bot marcó el lead como prioridad (caliente / cita propuesta): el asesor debe intervenir. */
  ATTENTION_PRIORITY: 'ATTENTION_PRIORITY',
  /** El asesor no registró nada en el plazo y el bot retomó la conversación. */
  ATTENTION_RESUMED: 'ATTENTION_RESUMED',
  /** El bot agendó una cita por WhatsApp (al asesor; al coordinador si quedó con otro asesor). */
  BOT_APPOINTMENT: 'BOT_APPOINTMENT',
  /** El bot llegó al presupuesto mensual y dejó de responder con modelos (o del todo). */
  BOT_BUDGET: 'BOT_BUDGET',
  /** 7.22: la otra parte confirmó la cita concretada; falta tu confirmación. */
  APPOINTMENT_CONFIRMATION: 'APPOINTMENT_CONFIRMATION',
  /** Una cita en la que participas se canceló, cambió de fecha o de asesor de sala, o se reemplazó por otra. */
  APPOINTMENT_CHANGED: 'APPOINTMENT_CHANGED',
  /** G1: la persona de un lead tuyo volvió a registrarse (o alguien intentó registrarla) por otro medio. */
  LEAD_RECONTACT: 'LEAD_RECONTACT',
  /** Lote 5 · H1: alguien devolvió o anuló una separación / venta de la empresa (aviso a quienes coordinan). */
  DEAL_UNDONE: 'DEAL_UNDONE',
  /** Lote 5 · H2: un asesor intentó separar o vender una unidad que otra persona ya tiene (aviso a quienes coordinan). */
  UNIT_TAKEN: 'UNIT_TAKEN',
  /**
   * Lote 6 · I1: leads esperando en la bolsa, a quienes coordinan el proyecto. Con `leadId`, un lead que volvió a
   * la bolsa por la reasignación automática; sin `leadId`, el resumen diario («N leads esperan en la bolsa»).
   */
  POOL_WAITING: 'POOL_WAITING',
  /** Lote 6 · I2: un asesor fue dado de baja o cambió de rol y sus leads se traspasaron (aviso a quienes coordinan). */
  ADVISOR_HANDOVER: 'ADVISOR_HANDOVER',
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export interface NotificationDto {
  id: string;
  type: NotificationType;
  /** Empresa del aviso (null en los avisos sin empresa); la web lleva el resumen de la bolsa a Equipo → Bolsa de esa empresa. */
  companyId: string | null;
  title: string;
  body: string | null;
  leadId: string | null;
  readAt: string | null;
  createdAt: string;
}

export const markReadSchema = z.object({
  ids: z.array(z.string().uuid()).optional(),
  all: z.boolean().optional(),
});
